export default __webpack_public_path__ + "static/media/before@3x.93c93fae.png";